import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PieSaldoAcreedoresPorEmpresa from '../PieSaldoAcreedoresPorEmpresa/PieSaldoAcreedoresPorEmpresa';
import TablaMultiempresa from '../TablaMultiempresa/TablaMultiempresa';
import { fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';

import * as actions from '../../../../store/actions/index';

const MultiChartSaldoAcreedorPorEmpresa = (props) => {
    const [viewAsPie, setViewAsPie] = useState(true);

    useEffect(() => {
        if (!props.estaCargado && !props.estaOculto && props.ejecucionDePagina) 
          props.onLoadChart();
        
    }, [props.ejecucionDePagina]);
    
    const handleChangeView = () => {
        setViewAsPie(!viewAsPie)
    }

    return(
        viewAsPie 
        ? 
            <PieSaldoAcreedoresPorEmpresa 
                ejecucionDePagina={props.ejecucionDePagina}
                onPorcionClick={props.onPorcionClick}
                onChangeViewClick={handleChangeView}
                title={`Saldo acreedores por empresa al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalSaldos)}`}
                height={300}
                width={'100%'}
            />
        : 
            <TablaMultiempresa 
                empresas={props.saldosPorEmpresa}
                onChangeViewClick={handleChangeView}
                title={`Saldo acreedores por empresa al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalSaldos)}`}
                height={245}
                width={'100%'}
            />
    )
}

const mapStateToProps = (state) => {
    return {
      saldosPorEmpresa: state.multiempresa.saldoAcreedoresPorEmpresa.saldos,
      totalSaldos: state.multiempresa.saldoAcreedoresPorEmpresa.totalSaldos,
      loading: state.multiempresa.saldoAcreedoresPorEmpresa.loading,
      estaCargado: state.multiempresa.saldoAcreedoresPorEmpresa.estaCargado,
      estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.saldoAcreedoresMultiempresa
    };
  };
  
const mapDispatchToProps = (dispatch) => {
    return {
        onLoadChart: () => dispatch(actions.loadSaldoAcreedoresPorEmpresa())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiChartSaldoAcreedorPorEmpresa);